export default __webpack_public_path__ + "static/media/recycled.249beb75.jpg";